import React from 'react';
import { Table } from 'semantic-ui-react';
import MessageCell from '@/components/table/MessageCell';

const NoAttachmentsRow = ({ colSpan }) => (
  <Table.Row>
    <MessageCell colSpan={colSpan} className="no-content" messageId="dataset.attachments.none.placeholder.title" />
  </Table.Row>
);

export default NoAttachmentsRow;
